export default [
    {
        single: '#407c2b',
        kept: [[255,255,0], [236,242,4], [217,229,9], [198,216,13], [153,185,23], [109,155,33], [64,124,43]],
        appeared: [[0,0,0], [239,243,255], [198,219,239], [158,202,225], [107,174,214], [49,130,189], [8,81,156]]
    },
    {
        single: '#388E36',
        kept: [[255,109,0], [255,151,0], [255,192,0], [255,234,0], [189,203,20], [122,173,40], [56,142,54]],
        appeared: [[0,0,0], [239,243,255], [198,219,239], [158,202,225], [107,174,214], [49,130,189], [8,81,156]]
    }
]



// WEBPACK FOOTER //
// ./src/colors.js